import { render, staticRenderFns } from "./VideoSelectorStep.vue?vue&type=template&id=534b01ba"
import script from "./VideoSelectorStep.vue?vue&type=script&lang=js"
export * from "./VideoSelectorStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('534b01ba')) {
      api.createRecord('534b01ba', component.options)
    } else {
      api.reload('534b01ba', component.options)
    }
    module.hot.accept("./VideoSelectorStep.vue?vue&type=template&id=534b01ba", function () {
      api.rerender('534b01ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/VideoSelectorStep.vue"
export default component.exports